import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Loader2 — Skeleton de chargement pour les tableaux d'interventions.
 *
 * Usage :
 *   <app-loader2 [isLoading]="isTableLoading" [rows]="6"></app-loader2>
 *   <!-- puis le tableau réel -->
 *   <div *ngIf="!isTableLoading">...</div>
 */
@Component({
  selector: 'app-loaderIntervantion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loaderIntervantion.component.html',
  styleUrls: ['./loaderIntervantion.component.css'],
})
export class loaderIntervantion {
  /** Affiche le skeleton si true, masque si false */
  @Input() isLoading: boolean = true;

  /** Nombre de lignes skeleton à afficher */
  @Input() rows: number = 6;

  /** Retourne un tableau de longueur [rows] pour *ngFor */
  get skeletonRows(): number[] {
    return Array.from({ length: this.rows }, (_, i) => i);
  }
}